import React from 'react';

const OnlineStatusIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      width="7" 
      height="6" 
      viewBox="0 0 7 6" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <circle cx="3.41992" cy="3" r="3" fill="#10B981"/>
    </svg>
  );
};

export default OnlineStatusIcon;
